export const KonvaCropper = {
	applyCrop(shape) {
		let fillCrop = null;
		const strokeOffset = shape.hasStroke() ? shape.strokeWidth() : 0;
		if (shape.getAttr('crop') && shape.getAttr('crop').width !== 0) { // customer crop
			fillCrop = this.getCustomCropParams(
				shape.fillPatternImage(),
				{
					width: (shape.width() || shape.radiusX() * 2) - strokeOffset,
					height: (shape.height() || shape.radiusY() * 2) - strokeOffset
				},
				{ x: shape.scaleX(), y: shape.scaleY() },
				shape.getAttr('crop'),
				shape.fillPatternRotation(),
				shape.getAttr('photoFlip') || 1 // defult 1
			);
		}
		else {
			fillCrop = this.getAutoCenterCropParams(
				shape.fillPatternImage(),
				{
					width: (shape.width() || shape.radiusX() * 2) - strokeOffset,
                    height: (shape.height() || shape.radiusY() * 2) - strokeOffset
				},
				{ x: shape.scaleX(), y: shape.scaleY() },
				shape.fillPatternRotation() % 180 !== 0,
				shape.getAttr('photoFlip') || 1 // defult 1
			);
		}
		if (shape.getClassName() === 'Rect') {
			shape.setAttrs({
				fillPatternX: (shape.width() / 2),
				fillPatternY: (shape.height() / 2)
			});
		} else if (shape.getClassName() === 'Path' || shape.getClassName() === 'Line') {
			const clientRect = shape.getClientRect({ skipTransform: true, skipStroke: true, skipShadow:true });
			shape.setAttrs({
				fillPatternX: (clientRect.x + (clientRect.width / 2)),
				fillPatternY: (clientRect.y + (clientRect.height / 2))
			});
		}
		shape.setAttrs(fillCrop);
	},
	getAutoCenterCropParams(image, size, scale, rot90base, flip) {
		/*if (rot90base) {
			[scale.x, scale.y] = [scale.y, scale.x];
		}
		const width = (rot90base ? size.height : size.width) * scale.x;
		const height = (rot90base ? size.width : size.height) * scale.y;*/
        if (!image) return undefined; // brak obrazka, nie ma co robić
		const W = image.width;
		const H = image.height;
		const _W = (rot90base ? H : W);
		const _H = (rot90base ? W : H);

		let flipX = 1, flipY = 1;
		if (flip < 1) {
			flipX = rot90base ? 1 : -1;
			flipY = rot90base ? -1 : 1;
		}

		const aspectRatio = (size.width * scale.x) / (size.height * scale.y);

		let newWidth;
		let newHeight;
		let newScale;
        //let newCrop = { x: 0, y: 0, width: 0, height: 0, originalCenterPointX:0, originalCenterPointY:0 };

		const imageRatio = _W / _H;

		if (aspectRatio >= imageRatio) {
			newWidth = _W;
			newHeight = _W / aspectRatio;
			newScale = (size.width * scale.x) / newWidth;

		} else {
			newWidth = _H * aspectRatio;
			newHeight = _H;
			newScale = (size.height * scale.y) / newHeight;
		}
		/*
		newCrop.width = newWidth / _W;
        newCrop.height = newHeight / _H;
		newCrop.x = (_W - newWidth) / 2 / _W;
		newCrop.y = (_H - newHeight) / 2 / _H;
		newCrop.originalCenterPointX = newCrop.x + (newCrop.width / 2);
		newCrop.originalCenterPointY = newCrop.y + (newCrop.height / 2);

        console.log("Crop:", newCrop);
		*/
		if (rot90base) {
			[scale.x, scale.y] = [scale.y, scale.x];
		}

		return {
			fillPatternOffset: { x: image.width / 2, y: image.height / 2 },
			fillPatternScale: { x: newScale * flipX / scale.x, y: newScale * flipY / scale.y }, //usunięcie skali obiektu nadrzędnego
		};
	},
	getCustomCropParams(image, size, scale, crop, rotation, flip) {
		let rot90base = rotation % 180 !== 0;
		let flipX = 1, flipY = 1;
		if (flip < 1) {
			flipX = rot90base ? 1 : -1;
			flipY = rot90base ? -1 : 1;
		}
		const rad = rotation * Math.PI / 180;
		//krok 1 - ustalenie W,_W i H,_H
		// rozmiary zdjęcia
		const W = image.width;
		const H = image.height;
		const _W = (rot90base ? H : W);
		const _H = (rot90base ? W : H);

		// rozmiary kadru
		const cW = W * (rot90base ? crop.height : crop.width);
		const cH = H * (rot90base ? crop.width : crop.height);
		const c_W = (rot90base ? cH : cW);
		const c_H = (rot90base ? cW : cH);

		/*console.log("Crop:", c_W, ",", c_H);
		console.log("Placeholder:", size.width * scale.x, ",", size.height * scale.y);
		console.log("Crop ratio:", c_W / c_H);
		console.log("Placeholder ratio:", (size.width * scale.x) / (size.height * scale.y));
		if (c_W / c_H !== (size.width * scale.x) / (size.height * scale.y)) {
			console.log("Ratio mismatch");
		}*/

		// Macierz M = S * R, czyli najpier obrót, potem skalowanie:
		// [ scaleX * cos, -scaleX * sin ]
		// [ scaleY * sin,  scaleY * cos ]  
		// flip --> scaleX dla obliczeń
		//krok 2 - _xo, _yo
		let xo = -(_W / 2) - (((-W / 2) * flip * Math.cos(rad)) + ((-H / 2) * (-flip) * Math.sin(rad)));// xo - x'
		let yo = -(_H / 2) - (((-W / 2) * 1 * Math.sin(rad)) + ((-H / 2) * 1 * Math.cos(rad)));// yo - y'
		//krok 3 - skala
		let newScale = Math.max((size.width * scale.x) / c_W, (size.height * scale.y) / c_H); // skala
		// krok 4 - przesunięcie 
		let x = xo + (crop.x * _W) + (c_W / 2);
		let y = yo + (crop.y * _H) + (c_H / 2);

		let offsetX, offsetY;

		// krok 5 - poprawka na rotację układu współżędnych
		offsetX = (x * Math.cos(rad) + y * Math.sin(rad)) * flipX;
		offsetY = (-x * Math.sin(rad) + y * Math.cos(rad)) * flipY;

		if (rot90base) {
			[scale.x, scale.y] = [scale.y, scale.x];
		}

		return {
			fillPatternOffset: { x: offsetX, y: offsetY },
			fillPatternScale: { x: newScale * flipX / scale.x, y: newScale * flipY / scale.y }, //usunięcie skali obiektu nadrzędnego
		};
	},
	calculateNewPseudoCrop(item, oldPlaceholderAspectRatio) {
		let crop = item.getAttr('crop');
        let image = item.fillPatternImage();
		if (!crop || crop.width === 0 || !image) return;
		let rot90base = item.fillPatternRotation() % 180 !== 0;

		//krok 1 - ustalenie W,_W i H,_H
		// rozmiary zdjęcia
		const W = image.width;
		const H = image.height;
		//rozmiaty po obrocie
		const _W = (rot90base ? H : W);
		const _H = (rot90base ? W : H);

		// rozmiary starego kadru
		const c_W = _W * crop.width;
		const c_H = _H * crop.height;

        // odczytanie środka kadru nadanego przez użytkownika
		let centerPoint_x = crop.originalCenterPointX * _W;
		let centerPoint_y = crop.originalCenterPointY * _H;
		
		let new_c_W;
		let new_c_H;
		const imageRatio = _W / _H;
		const aspectRatio = (item.width() * item.scaleX()) / (item.height() * item.scaleY());

        // ustalenie skali użytkownika (const nadawane przy kadrowaniu)
		//let old_c_W_scale1 = oldPlaceholderAspectRatio >= imageRatio ? _W : _H * oldPlaceholderAspectRatio; //fit in na szerokość
		//const olduseScale = old_c_W_scale1 / c_W; // ile razy trzeba by powiększyć żeby to był fit in
		const useScale = oldPlaceholderAspectRatio >= imageRatio ? 1 / crop.width : 1 / crop.height;
		//console.log("Old use scale:", olduseScale, "New use scale:", useScale);

        if (aspectRatio >= imageRatio) { // fit in w nowych proporcjach
			new_c_W = _W;
			new_c_H = _W / aspectRatio;

		} else {
			new_c_W = _H * aspectRatio;
			new_c_H = _H;
		}
		// zastosowanie skali użytkownika
		new_c_W /= useScale;
		new_c_H /= useScale;

		// ustalenie czy kadr z aktualnym środkiem zmieści się w zdjęciu - jeśli nie to wyznaczenie offsetu
		let closestImageEdgeXAx;
		let closestImageEdgeYAx;
		let offsetXSign = 1;
		let offsetYSign = 1;

		if (centerPoint_x < _W - centerPoint_x) { 
			closestImageEdgeXAx = centerPoint_x;
            offsetXSign = -1; // jesli wystaje to na minusie w układzie współrzędnych zdjęcia - po lewej stronie
		} else {
            closestImageEdgeXAx = _W - centerPoint_x;
			offsetXSign = 1; // jesli wystaje to na plusie w układzie współrzędnych zdjęcia - po prawej stronie stronie
		}

		if (centerPoint_y < _H - centerPoint_y) {
            closestImageEdgeYAx = centerPoint_y;
			offsetYSign = -1; // jesli wystaje to na minusie w układzie współrzędnych zdjęcia - u góry
        } else {
            closestImageEdgeYAx = _H - centerPoint_y;
			offsetYSign = 1; // jesli wystaje to na plusie w układzie współrzędnych zdjęcia - u dołu
		}

		//let closestImageEdgeXAx = Math.min(centerPoint_x, _W - centerPoint_x);
		//let closestImageEdgeYAx = Math.min(centerPoint_y, _H - centerPoint_y);
		let offsetX = Math.max((new_c_W / 2) - closestImageEdgeXAx, 0) * offsetXSign;
        let offsetY = Math.max((new_c_H / 2) - closestImageEdgeYAx, 0) * offsetYSign;
		let new_c_x = centerPoint_x - offsetX - (new_c_W / 2);
		let new_c_y = centerPoint_y - offsetY - (new_c_H / 2);  

		item.setAttrs({
			crop: {
				...crop,
				x: new_c_x / _W,
				y: new_c_y / _H,
				width: new_c_W / _W,
				height: new_c_H / _H
			}
		});
	},
	setCropCenterPoint(item) {
		let crop = item.getAttr('crop');
		if (!crop ) return;
		item.setAttrs({
			crop: {
				...crop,
				originalCenterPointX: crop.x + (crop.width / 2),
                originalCenterPointY: crop.y + (crop.height / 2)
			}
		});
	}
}
	